var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13_4725)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.28 13.14C26.28 5.88297 20.397 0 13.14 0C5.88297 0 0 5.88297 0 13.14C0 19.6985 4.80508 25.1346 11.0869 26.1204V16.9383H7.75055V13.14H11.0869V10.2451C11.0869 6.95188 13.0486 5.13281 16.05 5.13281C17.4872 5.13281 18.9914 5.38945 18.9914 5.38945V8.62313H17.3345C15.7023 8.62313 15.1931 9.63609 15.1931 10.6763V13.14H18.8374L18.2548 16.9383H15.1931V26.1204C21.4749 25.1346 26.28 19.6985 26.28 13.14Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13_4725"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.28,
    height: 26.28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialFacebook);
export default __webpack_public_path__ + "static/media/social-facebook.e4772c799e31f50d20a02881356977e9.svg";
export { ForwardRef as ReactComponent };